(function () {
  const config = window.lazFreeGift;
  if (!config?.cartSync || !config.productHandles?.length) return;

  const GIFT_PROP = config.lineProperty;
  const LOG = '[laz-free-gift]';
  let syncing = false;

  function cartPageSections() {
    const itemsEl = document.getElementById('main-cart-items');
    if (!itemsEl?.dataset.id) return null;
    const footerEl = document.getElementById('main-cart-footer');
    return {
      itemsId: itemsEl.dataset.id,
      footerId: footerEl?.dataset.id ?? null,
    };
  }

  function sectionsPayload() {
    const sections = ['cart-drawer', 'cart-icon-bubble'];
    const cartPage = cartPageSections();
    if (cartPage) {
      sections.push(cartPage.itemsId);
      if (cartPage.footerId) sections.push(cartPage.footerId);
    }
    return {
      sections: sections.join(','),
      sections_url: window.location.pathname,
    };
  }

  function isGiftLine(item) {
    return item.properties?.[GIFT_PROP] === '1';
  }

  function qualifyingTotalCents(cart) {
    return cart.items.reduce((sum, item) => {
      if (isGiftLine(item)) return sum;
      return sum + item.final_line_price;
    }, 0);
  }

  function giftLines(cart) {
    return cart.items.filter(isGiftLine);
  }

  function giftQuantity(cart) {
    return cart.items.reduce((sum, item) => (isGiftLine(item) ? sum + item.quantity : sum), 0);
  }

  function targetGiftQuantity(cart) {
    if (config.thresholdCents <= 0) return 0;
    return Math.floor(qualifyingTotalCents(cart) / config.thresholdCents);
  }

  function needsGiftMutation(cart) {
    return targetGiftQuantity(cart) !== giftQuantity(cart);
  }

  function setGiftLoading(active) {
    document.querySelectorAll('[data-laz-free-gift-sync]').forEach((el) => {
      el.toggleAttribute('hidden', !active);
    });

    document.querySelector('cart-drawer')?.classList.toggle('cart-drawer--gift-syncing', active);
    document.querySelector('cart-items')?.classList.toggle('cart-items--gift-syncing', active);
  }

  function variantInventoryScore(variant) {
    if (!variant.inventory_management) return Infinity;
    return variant.inventory_quantity ?? 0;
  }

  async function pickGiftVariantId() {
    const products = await Promise.all(
      config.productHandles.map((handle) =>
        fetch(`/products/${handle}.js`).then((res) => {
          if (!res.ok) console.warn(LOG, `Could not load /products/${handle}.js — is it published to Online Store?`);
          return res.ok ? res.json() : null;
        })
      )
    );

    let best = null;
    for (const product of products) {
      if (!product) continue;

      for (const variant of product.variants) {
        if (!variant.available) continue;
        if (!best || variantInventoryScore(variant) > variantInventoryScore(best)) {
          best = variant;
        }
      }
    }

    return best?.id ?? null;
  }

  async function fetchCart() {
    return fetch('/cart.js').then((r) => r.json());
  }

  function parseSectionDoc(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function replaceJsContents(sectionHtml, targetSelector) {
    const target = document.querySelector(targetSelector);
    const source = parseSectionDoc(sectionHtml).querySelector('.js-contents');
    if (target && source) target.innerHTML = source.innerHTML;
  }

  function replaceFromDoc(selector, doc) {
    const target = document.querySelector(selector);
    const source = doc.querySelector(selector);
    if (target && source) target.replaceWith(source);
  }

  function paintCartIconBubble(parsedState) {
    const sectionHtml = parsedState.sections?.['cart-icon-bubble'];
    if (!sectionHtml) return;

    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      applyDrawerSections(drawer, { sections: { 'cart-icon-bubble': sectionHtml } });
      return;
    }

    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble) {
      bubble.innerHTML = parseSectionDoc(sectionHtml).querySelector('.shopify-section')?.innerHTML ?? '';
    }
  }

  function syncDrawerEmptyState(drawer, itemCount) {
    if (itemCount == null) return;

    drawer.classList.toggle('is-empty', itemCount === 0);

    const drawerItems = drawer.querySelector('cart-drawer-items');
    if (drawerItems) drawerItems.classList.toggle('is-empty', itemCount === 0);
  }

  function applyDrawerSections(drawer, parsedState) {
    drawer.getSectionsToRender().forEach((section) => {
      const sectionHtml = parsedState.sections?.[section.id];
      if (!sectionHtml) return;

      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!sectionElement) return;

      sectionElement.innerHTML = drawer.getSectionInnerHTML(sectionHtml, section.selector);
    });
  }

  function paintDrawerFull(parsedState, { open = false } = {}) {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || !parsedState?.sections?.['cart-drawer']) return false;

    const inner = drawer.querySelector('.drawer__inner');
    if (inner?.classList.contains('is-empty') && parsedState.item_count > 0) {
      inner.classList.remove('is-empty');
    }

    applyDrawerSections(drawer, parsedState);
    syncDrawerEmptyState(drawer, parsedState.item_count);

    const overlay = drawer.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));

    if (open) drawer.open();
    return true;
  }

  function syncPaidRowIndices(liveTbody, sourceTbody) {
    const livePaid = [...liveTbody.querySelectorAll('tr.cart-item:not([data-laz-free-gift])')];
    const sourcePaid = [...sourceTbody.querySelectorAll('tr.cart-item:not([data-laz-free-gift])')];

    livePaid.forEach((liveRow, i) => {
      const sourceRow = sourcePaid[i];
      if (!sourceRow) return;

      if (sourceRow.id) liveRow.id = sourceRow.id;

      const sourceIndexed = [...sourceRow.querySelectorAll('[data-index]')];
      const liveIndexed = [...liveRow.querySelectorAll('[data-index]')];
      sourceIndexed.forEach((sourceEl, j) => {
        const liveEl = liveIndexed[j];
        if (!liveEl) return;
        liveEl.dataset.index = sourceEl.dataset.index;
        if (sourceEl.id) liveEl.id = sourceEl.id;
      });

      const sourceError = sourceRow.querySelector('.cart-item__error');
      const liveError = liveRow.querySelector('.cart-item__error');
      if (sourceError?.id && liveError) liveError.id = sourceError.id;

      const sourceRemove = sourceRow.querySelector('cart-remove-button');
      const liveRemove = liveRow.querySelector('cart-remove-button');
      if (sourceRemove?.id && liveRemove) liveRemove.id = sourceRemove.id;
    });
  }

  function patchGiftRowsInTbody(liveTbody, sourceTbody) {
    const sourceRows = [...sourceTbody.querySelectorAll('tr.cart-item')];
    const liveNonGiftCount = liveTbody.querySelectorAll('tr.cart-item:not([data-laz-free-gift])').length;
    const sourceNonGiftCount = sourceRows.filter((row) => !row.hasAttribute('data-laz-free-gift')).length;

    if (liveNonGiftCount !== sourceNonGiftCount) return false;

    liveTbody.querySelectorAll('[data-laz-free-gift]').forEach((row) => row.remove());

    const liveNonGiftRows = [...liveTbody.querySelectorAll('tr.cart-item:not([data-laz-free-gift])')];
    let nonGiftIdx = 0;

    for (const sourceRow of sourceRows) {
      if (!sourceRow.hasAttribute('data-laz-free-gift')) {
        nonGiftIdx++;
        continue;
      }

      const clone = sourceRow.cloneNode(true);
      const anchor = liveNonGiftRows[nonGiftIdx];
      if (anchor) liveTbody.insertBefore(clone, anchor);
      else liveTbody.appendChild(clone);
    }

    syncPaidRowIndices(liveTbody, sourceTbody);
    return true;
  }

  function patchGiftRows(liveRoot, sourceRoot) {
    const liveTbody = liveRoot?.querySelector('tbody');
    const sourceTbody = sourceRoot?.querySelector('tbody');
    if (!liveTbody || !sourceTbody) return false;
    return patchGiftRowsInTbody(liveTbody, sourceTbody);
  }

  function paintItemsPartial({ sectionHtml, itemsTag, onPatchFail, extras = [] }) {
    if (!sectionHtml) return false;

    const liveItems = document.querySelector(itemsTag);
    if (!liveItems) return false;

    const doc = parseSectionDoc(sectionHtml);
    const sourceItems = doc.querySelector(itemsTag);
    if (!sourceItems) return false;

    if (!patchGiftRows(liveItems, sourceItems)) onPatchFail(doc);
    extras.forEach((selector) => replaceFromDoc(selector, doc));
    return true;
  }

  function syncCartPageEmptyState(itemCount) {
    if (itemCount == null) return;

    const cartItems = document.querySelector('cart-items');
    const cartFooter = document.getElementById('main-cart-footer');
    if (cartItems) cartItems.classList.toggle('is-empty', itemCount === 0);
    if (cartFooter) cartFooter.classList.toggle('is-empty', itemCount === 0);
  }

  function paintDrawerPartial(parsedState) {
    const drawer = document.querySelector('cart-drawer');
    const sectionHtml = parsedState?.sections?.['cart-drawer'];
    if (!drawer || !sectionHtml) return false;

    paintItemsPartial({
      sectionHtml,
      itemsTag: 'cart-drawer-items',
      onPatchFail: (doc) => replaceFromDoc('cart-drawer-items', doc),
      extras: ['.laz-cart-promos', '[data-laz-free-gift-sync]', '.cart-drawer__footer'],
    });

    paintCartIconBubble(parsedState);
    syncDrawerEmptyState(drawer, parsedState.item_count);
    return true;
  }

  function paintCartPartial(parsedState) {
    const cartPage = cartPageSections();
    if (!cartPage?.itemsId || !parsedState.sections?.[cartPage.itemsId]) return false;

    const itemsHtml = parsedState.sections[cartPage.itemsId];
    paintItemsPartial({
      sectionHtml: itemsHtml,
      itemsTag: 'cart-items',
      onPatchFail: () => replaceJsContents(itemsHtml, '#main-cart-items .js-contents'),
    });

    if (cartPage.footerId && parsedState.sections[cartPage.footerId]) {
      replaceJsContents(parsedState.sections[cartPage.footerId], '#main-cart-footer .js-contents');
    }

    syncCartPageEmptyState(parsedState.item_count);
    paintCartIconBubble(parsedState);
    return true;
  }

  function paintCartFull(parsedState) {
    const cartPage = cartPageSections();
    if (!cartPage) return false;

    if (parsedState.sections?.[cartPage.itemsId]) {
      replaceJsContents(parsedState.sections[cartPage.itemsId], '#main-cart-items .js-contents');
    }
    if (cartPage.footerId && parsedState.sections?.[cartPage.footerId]) {
      replaceJsContents(parsedState.sections[cartPage.footerId], '#main-cart-footer .js-contents');
    }

    syncCartPageEmptyState(parsedState.item_count);
    paintCartIconBubble(parsedState);
    return true;
  }

  function formatMoney(cents, symbol) {
    return symbol + (cents / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }

  function refreshFreeShipWidgets(cartTotalCents) {
    document.querySelectorAll('[data-laz-free-ship]').forEach((root) => {
      root.dataset.lazCartTotalCents = String(cartTotalCents);

      const thresholdCents = parseInt(root.dataset.lazThresholdCents, 10) || 0;
      const textEl = root.querySelector('[data-laz-free-ship-text]');
      const fillEl = root.querySelector('[data-laz-free-ship-fill]');
      const bar = root.querySelector('[role="progressbar"]');
      if (!textEl) return;

      const symbol = root.dataset.lazCurrencySymbol || '';
      const underText = root.dataset.lazUnderThresholdText || '';
      const overText = root.dataset.lazOverThresholdText || '';
      const pct = thresholdCents <= 0 ? 100 : Math.min(100, Math.round((cartTotalCents / thresholdCents) * 100));
      const unlocked = cartTotalCents >= thresholdCents;

      textEl.textContent = unlocked
        ? overText
        : underText.replace(/\{\{\s*amount\s*\}\}/g, formatMoney(thresholdCents - cartTotalCents, symbol));

      if (fillEl && bar) {
        fillEl.style.width = pct + '%';
        bar.setAttribute('aria-valuenow', pct);
      }
    });
  }

  async function fetchSectionsState() {
    const cartPage = cartPageSections();
    const [drawerHtml, bubbleHtml, cart] = await Promise.all([
      fetch(`${routes.cart_url}?section_id=cart-drawer`).then((r) => r.text()),
      fetch(`${routes.cart_url}?section_id=cart-icon-bubble`).then((r) => r.text()),
      fetchCart(),
    ]);

    const sections = {
      'cart-drawer': drawerHtml,
      'cart-icon-bubble': bubbleHtml,
    };

    if (cartPage) {
      const cartFetches = [
        fetch(`${routes.cart_url}?section_id=${cartPage.itemsId}`).then((r) => r.text()),
      ];
      if (cartPage.footerId) {
        cartFetches.push(fetch(`${routes.cart_url}?section_id=${cartPage.footerId}`).then((r) => r.text()));
      }
      const cartHtml = await Promise.all(cartFetches);
      sections[cartPage.itemsId] = cartHtml[0];
      if (cartPage.footerId) sections[cartPage.footerId] = cartHtml[1];
    }

    return { ...cart, sections };
  }

  function sectionsMissing(parsedState) {
    if (!parsedState?.sections?.['cart-drawer']) return true;
    const cartPage = cartPageSections();
    if (cartPage && !parsedState.sections?.[cartPage.itemsId]) return true;
    return false;
  }

  function cartApiUrl(url) {
    return url.endsWith('.js') ? url : `${url}.js`;
  }

  async function postCart(url, body) {
    const jsonUrl = cartApiUrl(url);
    const response = await fetch(jsonUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    });

    const text = await response.text();
    try {
      return JSON.parse(text);
    } catch {
      console.error(LOG, 'Cart API returned non-JSON', {
        url: jsonUrl,
        status: response.status,
        preview: text.slice(0, 200),
      });
      return { status: response.status || 500, message: 'Cart API returned non-JSON response.' };
    }
  }

  async function addGift(quantity) {
    let variantId = config.giftVariantId;
    if (!variantId) variantId = await pickGiftVariantId();
    if (!variantId) {
      console.warn(LOG, 'No available gift variant found.');
      return null;
    }

    const response = await postCart(window.routes.cart_add_url, {
      id: variantId,
      quantity,
      properties: { [GIFT_PROP]: '1' },
      ...sectionsPayload(),
    });

    if (response.status) {
      console.warn(LOG, 'Could not add gift:', response.message || response.description);
      return null;
    }

    return response;
  }

  async function setGiftQuantity(line, quantity) {
    const response = await postCart(window.routes.cart_change_url, {
      id: line.key,
      quantity,
      ...sectionsPayload(),
    });

    if (response.status) {
      console.warn(LOG, 'Could not update gift quantity:', response.message || response.description);
      return null;
    }

    return response;
  }

  async function syncGift(cart) {
    const targetQty = targetGiftQuantity(cart);
    const lines = giftLines(cart);
    const currentQty = giftQuantity(cart);

    if (lines.length === 1 && currentQty === targetQty) return null;
    if (lines.length === 1) return setGiftQuantity(lines[0], targetQty);

    for (const line of lines) {
      const response = await setGiftQuantity(line, 0);
      if (response?.status) return null;
    }
    return targetQty > 0 ? addGift(targetQty) : null;
  }

  async function paintAfterMutation(response, { open = false } = {}) {
    let parsedState = response;
    if (sectionsMissing(parsedState)) {
      parsedState = await fetchSectionsState();
    }

    const cart = await fetchCart();
    parsedState.item_count = cart.item_count;
    parsedState.total_price = cart.total_price;

    const emptyOrOpen = parsedState.item_count === 0 || open;

    if (emptyOrOpen) {
      paintDrawerFull(parsedState, { open });
      if (cartPageSections()) paintCartFull(parsedState);
    } else {
      paintDrawerPartial(parsedState);
      if (cartPageSections()) paintCartPartial(parsedState);
    }

    refreshFreeShipWidgets(parsedState.total_price);
    return parsedState;
  }

  async function onCartUpdate(event) {
    if (syncing) return;

    syncing = true;
    try {
      const cart = await fetchCart();
      if (!needsGiftMutation(cart)) return;

      setGiftLoading(true);
      const response = await syncGift(cart);
      if (!response) return;

      await paintAfterMutation(response, {
        open: event?.source === 'product-form',
      });
    } finally {
      setGiftLoading(false);
      syncing = false;
    }
  }

  fetchCart().then(async (cart) => {
    if (syncing) return;
    if (!needsGiftMutation(cart)) return;

    syncing = true;
    try {
      setGiftLoading(true);
      const response = await syncGift(cart);
      if (!response) return;
      await paintAfterMutation(response);
    } finally {
      setGiftLoading(false);
      syncing = false;
    }
  });

  if (typeof subscribe === 'function' && PUB_SUB_EVENTS?.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
  }
})();
